// file: src/store/root/index.ts

export * from './Root.store';
